
<template>
  <div class="index" v-cloak>
    <!-- 头部 -->
    <Header/>
    <!-- 轮播图 -->
    <div class="carousel ab_carousel">
      <el-carousel :loop="false" :autoplay="false">
        <el-carousel-item v-for="(item, index) in aboutList" :key="index">
          <div class="cs_contain" :style='{ backgroundImage : "url(" + item.url + ")" }'>
            <div class="content-width">
              <div :class="['cs_word', index === 0 ? 'cs_word_white' : '']">
                <div v-cloak v-if="item.title1" class="title1">{{item.title1}}</div>
                <div v-cloak class="title2">{{item.title2}}</div>
                <!--                  <div v-cloak class="remark">{{item.remark}}</div>-->
              </div>
              <!--                <el-button type="primary" round class="use_btn" @click="useClick">申请试用</el-button>-->
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 品牌介绍 -->
    <div class="partner" style="height: 52rem;">
      <div class="content content-title">
        <div class="title">品牌介绍</div>
        <div class="remark" style="width: auto;">广州市智慧农业服务股份有限公司
          <span style="color: #000;">成立于2015年，是一家专注于打造"农田-流通-餐桌"农业产业链数字化解决方案的田家高新技术企业。我们领航成员企业赛通科技、米果智能、智慧真甜、晨诺科技，在效字农业、农产品流通、智慧食堂等领域为客户提供有克争力的产品、新决方案以及服务，智慧农业坚持创新、自律、谦虚、利他、担当。卓越的iSHARE价值观，与员工与合作伙伴，持续为客户为行业创造价值，推动农业产业链的数字化升级。
            </span>
        </div>
        <div class="video-box">
          <!-- 封面图 -->
          <img v-show="!isPlaying" :src="coverUrl" alt="视频封面" class="cover" @click="playVideo" />
          <!-- 视频（默认隐藏） -->
          <video
            v-show="isPlaying"
            ref="videoPlayer"
            :src="videoUrl"
            class="video"
            controls
          />
<!--          @play="isPlaying = true"-->
<!--          @pause="isPlaying = false"-->
        </div>
      </div>
    </div>

    <!-- 资质荣誉 -->
    <div class="partner" style="height: 51rem;background: #E8F5FF;">
      <div class="content content-title">
        <div class="title">资质荣誉</div>
        <div class="remark" style="width: auto;">
          逐光前行，荣誉加冕，每一份成就皆是砥砺奋进的见证，激励着我们迈向更高的目标
        </div>
        <img class="partner-bg" style="height: 33.75rem;" src="@/assets/img/about/pic/honor.jpg" />
      </div>
    </div>

    <!-- 团队实力 -->
    <div class="team" style="height: 35rem;" id="ab6">
      <div class="content content-title" style="height: auto;">
        <div class="title">团队实力</div>
        <div class="remark">汇聚多领域的行业精英，支撑构建农业全链条数字化服务体系</div>
      </div>
      <!-- 外层容器：控制可视区域 -->
      <div class="image-scroll-container partner-bg">
        <!-- 滚动内容容器：复制图片列表实现无缝衔接 -->
        <div class="scroll-content">
          <div
            class="scroll-item"
            v-for="(imgUrl, index) in scrollImageList"
            :key="index"
          >
            <img :src="imgUrl" alt="活动照片" />
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="partner link" style="height: 45.5rem;background: #E8F5FF;">
      <div class="content content-title" style="height: auto;">
        <div class="title">联系我们</div>
        <div class="remark" style="width: auto;">
<!--          逐光前行，荣誉加冕，每一份成就皆是砥砺奋进的见证，激励着我们迈向更高的目标-->
        </div>
        <div class="contact-container">
          <div class="contact-card">
            <!-- 电话模块 -->
            <div class="contact-item">
              <div class="icon-wrapper">
                <!-- 电话图标（可替换为实际图标库） -->
                <img class="icon" src="@/assets/img/about/pic/tel.jpg" />
              </div>
              <h3 class="item-title">总机电话</h3>
              <p class="item-content">400 8838 316、020-84661895</p>
            </div>

            <!-- 地址模块 -->
            <div class="contact-item">
              <div class="icon-wrapper">
                <!-- 定位图标 -->
                <img class="icon" src="@/assets/img/about/pic/local.jpg" />
              </div>
              <h3 class="item-title">地址</h3>
              <p class="item-content">广州市番禺区沙头街银平路98号2栋7楼</p>
            </div>

            <!-- 二维码模块 -->
            <div class="contact-item qrcode-group">
              <div class="qrcode-wrapper">
                <div class="qrcode-item">
                  <div class="qrcode-box">
                    <!-- 公众号二维码，替换为实际图片 -->
                    <img class="icon" src="@/assets/img/index/pic/code.jpg" />
                  </div>
                  <p class="qrcode-label">穗盈公众号</p>
                </div>
                <div class="qrcode-item">
                  <div class="qrcode-box">
                    <!-- 服务号二维码，替换为实际图片 -->
                    <img class="icon" src="@/assets/img/about/pic/qc2.jpg" />
                  </div>
                  <p class="qrcode-label">智慧农业服务号</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img class="map" src="@/assets/img/about/pic/map.jpg" />
    </div>

    <!-- 客服 -->
    <CustCare />
    <!-- 申请 -->
    <Apply ref="applyRef" />
    <!-- 页面申请 -->
    <ApplyIndex />
    <!-- 联系 -->
    <Contact />
    <!-- 尾部 -->
    <Footer />

  </div>

  <!--    <div class="bdsharebuttonbox" style="display:none;">-->
  <!--      <xx style="float: left; font-size: 12px;line-height:30px;"> </xx>-->
  <!--      <a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信" id="wx_share"></a>-->
  <!--    </div>-->
</template>
<!--<script>-->
<!--  let pUrl = window.location.href;-->
<!--  window._bd_share_config = { "common": { "bdSnsKey": {}, "bdText": "", "bdMini": "", "bdMiniList": false, "bdUrl": pUrl, "bdPic": "", "bdStyle": "", "bdSize": "" }, "share": {} };-->
<!--  with (document) 0[(getElementsByTagName('head')[0] || body).appendChild(createElement('script')).src = 'http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5)];-->
<!--</script>-->

<script>
import Header from '@/views/pc/components/header'
import Contact from '@/views/pc/components/contact'
import CustCare from '@/views/pc/components/custCare'
import Footer from '@/views/pc/components/footer'
import Apply from '@/views/pc/components/apply'
import ApplyIndex from '@/views/pc/components/applyIndex'
export default {
  name: "About",
  components: { Header, Contact, CustCare, Footer, Apply, ApplyIndex },
  data () {
    return {
      videoUrl: "https://zhnyoss.visfarm.com/website/introductory_video.mp4",
      coverUrl: require('@/assets/img/about/pic/videoImg.jpg'),
      isPlaying: false,
      teamCarouselPaused: false,
      imageList: [
        require('@/assets/img/about/pic/t1.jpg'),
        require('@/assets/img/about/pic/t2.jpg'),
        require('@/assets/img/about/pic/t3.jpg'),
        require('@/assets/img/about/pic/t4.jpg'),
        require('@/assets/img/about/pic/t5.jpg')
      ],
      // 关于我们轮播图
      aboutList: [
        {
          title1: '致力于中国农业',
          title2: '产业链数字化升级',
          // remark: '产业链数字化升级',
          url: require('@/assets/img/about/pic/about.jpg')
        }
      ],
      // 关于我们-荣誉
      honorList: [
        {en: '高新技术企业证书', ch: 'High-tech Enterprise Certificate'},
        {en: '智慧农业先进科技企业', ch: 'Smart Agriculture Advanced Technology Enterprise'},
        {en: '发明专利', ch: 'Invention patent'},
        {en: '实用新型专利证书', ch: 'Utility Model Patent Certificate'},
        {en: '质量管理体系认证证书', ch: 'Quality Management System Certificate'},
        {en: '信息技术服务管理体系认证证书', ch: 'Information technology service management system'},
        {en: '信息安全管理体系认证证书', ch: 'Information security management system certification'}
      ],
      // 关于我们-资质
      qualList: [
        {en: '计算机软件著作权登记证书', ch: 'Computer Software Copyright Registration Certificate'},
        {en: '物联网采集系统软件著', ch: 'IoT collection system software'},
        {en: '温湿度传感器检准证书', ch: 'Temperature and humidity sensor inspection certificate'},
        {en: '种植及溯源系统软著', ch: 'Planting and traceability system software'},
        {en: '风速传感器校准证书', ch: 'Wind speed sensor calibration certificate'},
        {en: '雨量传感器校准证书', ch: 'Rain sensor calibration certificate'}
      ]
    }
  },
  created () {
    //创建时执行跳转锚点位置
    // this.$nextTick(() => {
    //   this.getLocal();
    // });
  },
  computed:{
    scrollImageList() {
      return [...this.imageList, ...this.imageList]
    }
    // applyCheck() {
    //   const reg = /^1[3|5|7|8|9]\d{9}$/
    //   const { name, tel } = this.ruleForm
    //   if(name.length >= 2 && name.length<=5 && reg.test(tel)) return true
    //   else return false
    // }
  },
  //离开页面进行对localStorage  id销毁，避免其他入口进来有锚点问题
  destroyed() {
    sessionStorage.setItem("ab1", "");
    sessionStorage.setItem("ab2", "");
    sessionStorage.setItem("ab3", "");
    sessionStorage.setItem("ab4", "");
    sessionStorage.setItem("ab5", "");
    sessionStorage.setItem("ab6", "");
  },
  methods: {
    handleMouseEnter() {
      this.teamCarouselPaused = true;
    },
    handleMouseLeave() {
      this.teamCarouselPaused = false;
    },
    // 点击播放视频
    playVideo() {
      this.isPlaying = true;
      const video = this.$refs.videoPlayer;
      // 仅首次播放时加载视频，避免 load() 重置播放进度
      if (video.readyState === 0) {
        video.load();
      }
      video.play().catch(e => {
        console.error('播放失败:', e);
      });
    },
    getLocal() {
      //找到锚点id
      const selectId1 = sessionStorage.getItem("ab1");
      const selectId2 = sessionStorage.getItem("ab2");
      const selectId3 = sessionStorage.getItem("ab3");
      const selectId4 = sessionStorage.getItem("ab4");
      const selectId5 = sessionStorage.getItem("ab5");
      const selectId6 = sessionStorage.getItem("ab6");
      //如果对应id存在，就跳转
      if (selectId1) {
        document.getElementById(selectId1).scrollIntoView(true)
      }
      if (selectId2) {
        document.getElementById(selectId2).scrollIntoView(true)
      }
      if (selectId3) {
        document.getElementById(selectId3).scrollIntoView(true)
      }
      if (selectId4) {
        document.getElementById(selectId4).scrollIntoView(true)
      }
      if (selectId5) {
        document.getElementById(selectId5).scrollIntoView(true)
      }
      if (selectId6) {
        document.getElementById(selectId6).scrollIntoView(true)
      }
    },
    // 试用
    useClick () {
      this.applyVisible = true
      // this.closeApply()
    },
    // 清空申请值
    closeApply() {
      this.ruleForm.name = ''
      this.ruleForm.tel = ''
      this.ruleForm.company = ''
    },
    //在线客服
    online() {
      let href = 'https://p.qiao.baidu.com/cps/chat?siteId=17409992&userId=34503880&siteToken=dbadd38923e251ca2c0da0605366f46e'
      let a = document.createElement('a')
      a.setAttribute('href', href)
      a.setAttribute('target', '_black')
      document.body.appendChild(a);
      a.click();
    }
  }
}
</script>
<style lang="scss">
@import '@/styles/pc/common/index.scss';
</style>
<style lang="scss" scoped>
@import "@/styles/pc/carousel/index.scss";
@import '@/styles/pc/about/index.scss';
</style>



// WEBPACK FOOTER //
// src/views/pc/about.vue